import {
  getCapabilityDisplayName,
  getProviderCapabilitiesList,
} from "./vendorProfileCapabilities";

/** Map provider API capabilities into the Company Profile multi-select value. */
export function formatProviderCapabilitiesForForm(
  providerData,
  mergeSelected = (selected) => selected,
  rfis = []
) {
  return mergeSelected(
    getProviderCapabilitiesList(providerData).map((cap) => ({
      value: cap.rfi_id ?? cap.rfiId ?? cap.value,
      label: getCapabilityDisplayName(cap, rfis) || "",
    }))
  );
}

/** Keep Library Documents services when saving Company Profile capabilities. */
export function formatProviderCapabilitiesForPayload(
  selected,
  mergeSelected = (selectedValue) => selectedValue
) {
  return mergeSelected(selected)?.map((cap) => ({
    rfi_id: cap.value,
    rfi_name: cap.label,
  }));
}
